import { AppHelper } from './../appHelper/appHelper';
import { SecurityService } from '../services/security.service';
import { Observable, of as _of, ReplaySubject, throwError } from 'rxjs';
import { catchError, filter, map, finalize, concatMap, share, skipWhile, take } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { MessageBox } from '../message-box/message-box';
import { Router } from '@angular/router';
import { RefreshTokenService } from '../services/refresh-token-service/refresh-token-service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  private _tokenRefreshObservable: Observable<string>;

  constructor(
    private messageBox: MessageBox,
    private router: Router,
    private security: SecurityService,
    private refreshTokenService: RefreshTokenService,
  ) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.handleAuth(request)
      .pipe(
        concatMap(req => next.handle(req)),
        catchError(e => this.handleError(e)),
      );
  }

  handleAuth(request: HttpRequest<any>): Observable<HttpRequest<any>> {
    if (AppHelper.refreshTokens) {

      return this.getToken()
        .pipe(
          take(1), // This is required to complete the returned observable
          map(tk => this.addTokenToRequest(request, tk)),
        );

    } else {

      // Refreshing tokens is disabled
      const token = this.security.getAccessToken();
      let req = this.addTokenToRequest(request, token);
      return _of(req);

    }
  }

  /** When the token is expired, stops the pipe and initiates a token refresh */
  private getToken(): Observable<string> {

    if (this._tokenRefreshObservable) {
      return this._tokenRefreshObservable;
    }

    let token = this.security.getAccessToken();
    if (!token // User is not logged in
      || this.security.isTokenValid(token) // The token is valid and does not need to refresh
    ) {
      return _of(token);
    }

    // Token is expired. Try refreshing
    this._tokenRefreshObservable = this.refreshTokenService.Refresh()
      .pipe(
        map(() => {
          return this.security.getAccessToken();
        }),
        catchError(() => _of(token)),
        finalize(() => this._tokenRefreshObservable = null),
        share(),
      );
    return this._tokenRefreshObservable;
  }

  addTokenToRequest(request: HttpRequest<any>, token: string): HttpRequest<any> {
    if (!token) {
      return request;
    }

    let headerKeyValue: { [name: string]: string | string[]; } = {};
    headerKeyValue["Authorization"] = `Bearer ${token}`;
    // if (request.url.indexOf('/payment/GetTransactionDiferences') > 0)
    //   headerKeyValue["Content-Type"] = "multipart/form-data;" ;
    // else
    // if (!request.headers.has("Content-Type"))
    //   headerKeyValue["Content-Type"] = "application/json";

    return request.clone({
      setHeaders: headerKeyValue
    });
  }

  handleError(error: any): Observable<HttpEvent<any>> {
    var err: string;

    if (error instanceof HttpErrorResponse) {
      if (error.status == 401) {
        // return this.handleRefreshToken(req, next);
        this.redirectToLogin();
        err = 'خطای تشخیص هویت';
      } else if (error.status == 403, error.status == 500) {
        if (this.security.IsInBrowser)
          this.messageBox.showError("خطای سیستمی", "عملیات با خطا مواجه شد، لطفا مراتب را به واحد پشتیبانی سامانه سایه اطلاع دهید .");
        err = 'خطای سیستمی';
      }
      else if (error.status == 400 && error.error == "Invalid username or password." && error.ok == false) {
        if (this.security.IsInBrowser)
          this.messageBox.showError("ورود به سیسیتم", ". نام کاربری یا رمز عبور صحیح نیست");
        err = 'نام کاربری یا رمز عبور صحیح نیست.';
      }
    }
    return throwError(err);
  }

  redirectToLogin() {
    if (this.security.IsInBrowser) {
      // this.messageBox.showError("خطای تشخیص هویت", "لطفا دوباره وارد شوید .");
      this.security.clearUserDataStored();
      // this.router.navigate(['/register/person']);
    }
  }

}
